var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "eula-body mt-4 px-3" }, [
      _c("div", [
        _c("h5", [
          _vm._v(
            "Chariot MQTT Server by Cirrus Link Solutions Software License Agreement"
          ),
        ]),
        _c("p", [
          _c("b", [
            _vm._v(
              ' IMPORTANT - READ CAREFULLY: THIS CHARIOT MQTT SERVER BY CIRRUS LINK SOLUTIONS LLC® (THE "SOFTWARE") ") SOFTWARE LICENSE AGREEMENT ("CLSSLA") IS A LEGAL AGREEMENT BETWEEN YOU (EITHER AN INDIVIDUAL OR A SINGLE ENTITY) AND CIRRUS LINK SOLUTIONS LLC. BY INSTALLING, COPYING OR OTHERWISE USING THE SOFTWARE, YOU INDICATE YOUR ACCEPTANCE OF THE CLSSLA, INCLUDING THE LIMITED WARRANTY, DISCLAIMERS AND LIMITATION ON LIABILITY PROVISIONS. BY AGREEING TO THIS CLSSLA YOU ARE ALSO AGREEING TO RELEVANT THIRD PARTY SOFTWARE LICENSING AGREEMENTS FOR ANY OF THE MODULES YOU ARE UTILIZING. FURTHER,'
            ),
            _c("u", [
              _vm._v(
                " YOU AGREE THAT THIS CLSSLA CONTROLS ALL ASPECTS OF THE RELATIONSHIP BETWEEN THE PARTIES WITH REGARD TOTHE LICENSING OF THE SOFTWARE AND SUPERCEDES ANY OTHER AGREEMENT BETWEEN YOU AND CIRRUS LINK SOLUTIONS, INCLUDING, BUT NOT LIMITED TO, LICENSEE PURCHASE ORDERS AND/OR TERMS AND CONDITIONS, AND WHETHER ENTERED INTO BEFORE OR AFTER YOUR ACCEPTANCE OF THIS AGREEMENT."
              ),
            ]),
            _vm._v(
              " IF YOU DO NOT ACCEPT THE TERMS OF THIS AGREEMENT DON'T INSTALL, COPY OR OTHERWISE USE THE SOFTWARE."
            ),
          ]),
        ]),
        _c("p", [
          _c("b", [
            _vm._v(
              "BY DOWNLOADING, INSTALLING AND/OR IMPLEMENTING THIS SOFTWARE YOU AGREE TO THE FOLLOWING LICENSE:"
            ),
          ]),
        ]),
        _c("ol", { staticClass: "alpha-list-style" }, [
          _c("li", [
            _c("b", [_vm._v("DEFINITIONS.")]),
            _vm._v(
              ' "You" and "Licensee" refers to the person, entity or organization which is using the Software and any successor or assignee of same. "Cirrus Link" refers to Cirrus Link Solutions, LLC and its successors or manufacturer and owner of this Software. You understand that this Sparkplug Aware MQTT Server is protected under a provisional patent filed with the United States Patent office. '
            ),
          ]),
          _c("li", [
            _c("b", [_vm._v("AGREEMENT.")]),
            _vm._v(
              " After reading the CLSSLA, if You do not agree to all of the terms of the CLSSLA, You may not use the Software. Unless You have a different license agreement signed by an authorized representative of Cirrus Link that coversthe licensing of the Software, your use of this Software indicates your acceptance of the terms of this CLSSLA, including,but not limited to, the warranty, disclaimers and limitations on liability provisions. All updates to the Software shall be considered part of the Software and subject to the terms of the CLSSLA. Revisions to this CLSSLA may accompany updates to the Software, in which case by installing such update, Customer accepts the terms of the CLSSLA as revised. The CLSSLA is not otherwise subject to addition, amendment, modification or exception unless in writing signed by You and an authorized representative of Cirrus Link. If you do not agree to the terms of this CLSSLA, do not install or use the Software "
            ),
          ]),
          _c("li", [
            _c("b", [_vm._v("GRANT OF LICENSE.")]),
            _vm._v(
              " The Software is an original work and protected by copyright and patent laws protecting the author's rights and intellectualproperty. Cirrus Link reserves all rights to any reproduction of the Software, including its documentation, logos, trademarks, icons and interface in whole or in part. This CLSSLA does not give You the right to any technical support for,or upgrades to, the Software which Cirrus Link may offer from time to time. Cirrus Link may, at its option and as part of its sales policy, make such technical support and upgrades available to registered users of the Software under terms to be determined from time to time by Cirrus Link. "
            ),
            _c("ol", [
              _c("li", [
                _c("b", [_vm._v("Evaluation Copy.")]),
                _vm._v(
                  " You may use the Software without charge on an evaluation basis. In the unregistered version your use is limited by providing atwo hour runtime only. You must pay the license fee and activate your copy of the Software if you wish to use the Software without any limitation. "
                ),
              ]),
              _c("li", [
                _c("b", [_vm._v("Redistribution of Evaluation Copy.")]),
                _vm._v(
                  " If You are using the Software on an evaluation basis, You may make copiesof the evaluation Software as you wish; give exact copies of the original evaluation Software to anyone; and distribute the evaluation Software in its unmodified form via electronic means (Internet, BBS's, Shareware distribution libraries, CD-ROMs, etc.). You may not charge a fee for the copy or use of the evaluation Software itself, but You may charge a distribution fee that is reasonably related to any cost You incur distributing the evaluation Software (e.g. packaging). You must not represent in any manner whatsoever that You are selling the Software itself. Your distribution of the evaluation Software will not entitle You to any compensation from CirrusLink. You must distribute a copy of this CLSSLA with any copy of the Software. Anyone to whom You distributethe Software is subject to this CLSSLA "
                ),
              ]),
              _c("li", [
                _c("b", [_vm._v("Registered Copy.")]),
                _vm._v(
                  " After You have purchased the license for the Software and have received the serial number enabling the registered copy, You are licensed to copy the Software only into the memory of the number of computers corresponding to the number of licenses purchased. Under no other circumstances may the Software be operated at the same time on more than the number of computers for which You have paid a separate license fee. You may terminate this license at any time by destroying the original and all copies of the Software in whatever form you maintained it in. You may permanently transfer all of your rights under this CLSSLA provided You transfer all copies of the Software (including copies of all prior versions if the Software is an upgrade) and retain none, and the recipient agrees to the terms of this CLSSLA "
                ),
              ]),
              _c("li", [
                _c("b", [_vm._v("Virtual Machines.")]),
                _vm._v(
                  " If you plan to run the Software in multiple virtual computers or virtual servers, a license is required for each instance of the virtual computer or server where the Software will be installed. If you plan to install the Software in the host operating system of the computer where the virtual machines are running, a license will also be required for the host operating system. "
                ),
              ]),
              _c("li", [
                _c("b", [_vm._v("RESTRICTIONS.")]),
                _vm._v(
                  " You may not reverse engineer, de-compile or disassemble the Software, except and only to the extent that such activity is expressly permitted by applicable law notwithstanding this limitation. You may not rent, lease or lend the Software. You may not publish or publicly distribute any serial numbers, access codes, unlock-codes, passwords, or other end-user-specific registration information that would allow a third party to activate the Software without a valid license "
                ),
              ]),
            ]),
          ]),
          _c("li", [
            _c("p", [
              _c("b", [_vm._v("THIRD PARTY LICENSES AND COPYRIGHT NOTICES")]),
            ]),
            _c("p", [
              _vm._v(
                " The Software may contain software from the following entities, whose inclusion is governed by the following third-party licenses and require the following copyright notices. "
              ),
            ]),
            _c("ol", [
              _c("li", [
                _c("b", [_vm._v("Eclipse Paho Client")]),
                _c("p", [
                  _c("b", [
                    _vm._v(
                      "Copyright © 2014 Eclipse Paho. All Rights Reserved."
                    ),
                  ]),
                ]),
                _c("p", [
                  _vm._v(
                    " The Software contains Eclipse Paho Client, which is licensed under the Eclipse Public License, Version 1.0. You can get the full source code for Eclipse Paho Client at: "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://repo.eclipse.org/content/repositories/paho-releases/",
                      },
                    },
                    [
                      _vm._v(
                        "https://repo.eclipse.org/content/repositories/paho-releases"
                      ),
                    ]
                  ),
                  _vm._v(
                    " A copy of the Eclipse Public License, Version 1.0 is available at "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "http://www.eclipse.org/legal/epl-v10.html",
                      },
                    },
                    [_vm._v("http://www.eclipse.org/legal/epl-v10.html")]
                  ),
                ]),
              ]),
              _c("li", [
                _c("b", [_vm._v("Apache Shiro")]),
                _c("p", [
                  _c("b", [
                    _vm._v(
                      "Copyright © 2008-2020 The Apache Software Foundation"
                    ),
                  ]),
                ]),
                _c("p", [
                  _vm._v(
                    " The Software contains Apache Shiro, which is licensed under the Apache License, Version 2.0. You can get the full source code for Apache Log4j at: "
                  ),
                  _c("a", { attrs: { href: "https://shiro.apache.org/" } }, [
                    _vm._v("https://shiro.apache.org/"),
                  ]),
                  _vm._v(
                    " A copy of the Apache License, Version 2.0 is available at "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "http://www.apache.org/licenses/LICENSE-2.0",
                      },
                    },
                    [_vm._v("http://www.apache.org/licenses/LICENSE-2.0")]
                  ),
                ]),
              ]),
              _c("li", [
                _c("b", [_vm._v("Apache HttpClient")]),
                _c("p", [
                  _c("b", [
                    _vm._v(
                      "Copyright © 2005-2020 The Apache Software Foundation. All Rights Reserved."
                    ),
                  ]),
                ]),
                _c("p", [
                  _vm._v(
                    " The Software contains Apache HttpClient, which is licensed under the Apache License, Version 2.0. You can get the full source code for Apache HttpClient at: "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://hc.apache.org/httpcomponents-client-ga/",
                      },
                    },
                    [_vm._v("https://hc.apache.org/httpcomponents-client-ga")]
                  ),
                  _vm._v(
                    " A copy of the Apache License, Version 2.0 is available at "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "http://www.apache.org/licenses/LICENSE-2.0",
                      },
                    },
                    [_vm._v("http://www.apache.org/licenses/LICENSE-2.0")]
                  ),
                ]),
              ]),
              _c("li", [
                _c("b", [_vm._v("Apache HttpCore")]),
                _c("p", [
                  _c("b", [
                    _vm._v(
                      "Copyright © 2005-2020 The Apache Software Foundation. All Rights Reserved."
                    ),
                  ]),
                ]),
                _c("p", [
                  _vm._v(
                    " The Software contains Apache HttpCore, which is licensed under the Apache License, Version 2.0. You can get the full source code for Apache HttpCore at: "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://hc.apache.org/httpcomponents-client-ga/",
                      },
                    },
                    [_vm._v("https://hc.apache.org/httpcomponents-client-ga")]
                  ),
                  _vm._v(
                    " A copy of the Apache License, Version 2.0 is available at "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "http://www.apache.org/licenses/LICENSE-2.0",
                      },
                    },
                    [_vm._v("http://www.apache.org/licenses/LICENSE-2.0")]
                  ),
                ]),
              ]),
              _c("li", [
                _c("b", [_vm._v("Jackson Annotations")]),
                _c("p", [
                  _c("b", [
                    _vm._v("Copyright: 2013, FasterXML, LLC, Seattle, USA"),
                  ]),
                ]),
                _c("p", [
                  _vm._v(
                    " The Software contains Jackson Annotations, which is licensed under the Apache License, Version 2.0. You can get the full source code for Jackson Annotations at: "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://github.com/FasterXML/jackson-annotations",
                      },
                    },
                    [_vm._v("https://github.com/FasterXML/jackson-annotations")]
                  ),
                  _vm._v(
                    " A copy of the Apache License, Version 2.0 is available at "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "http://www.apache.org/licenses/LICENSE-2.0",
                      },
                    },
                    [_vm._v("http://www.apache.org/licenses/LICENSE-2.0")]
                  ),
                ]),
              ]),
              _c("li", [
                _c("b", [_vm._v("Jackson Core")]),
                _c("p", [
                  _c("b", [
                    _vm._v("Copyright: 2013, FasterXML, LLC, Seattle, USA"),
                  ]),
                ]),
                _c("p", [
                  _vm._v(
                    " The Software contains Jackson Core, which is licensed under the Apache License, Version 2.0. You can get the full source code for Jackson Core at: "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://github.com/FasterXML/jackson-core",
                      },
                    },
                    [_vm._v("https://github.com/FasterXML/jackson-core")]
                  ),
                  _vm._v(
                    " A copy of the Apache License, Version 2.0 is available at "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "http://www.apache.org/licenses/LICENSE-2.0",
                      },
                    },
                    [_vm._v("http://www.apache.org/licenses/LICENSE-2.0")]
                  ),
                ]),
              ]),
              _c("li", [
                _c("b", [_vm._v("Jackson Databind")]),
                _c("p", [
                  _c("b", [
                    _vm._v("Copyright: 2013, FasterXML, LLC, Seattle, USA"),
                  ]),
                ]),
                _c("p", [
                  _vm._v(
                    " The Software contains Jackson Databind, which is licensed under the Apache License, Version 2.0. You can get the full source code for Jackson Databind at: "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://github.com/FasterXML/jackson-databind/",
                      },
                    },
                    [_vm._v("https://github.com/FasterXML/jackson-databind")]
                  ),
                  _vm._v(
                    " A copy of the Apache License, Version 2.0 is available at "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "http://www.apache.org/licenses/LICENSE-2.0",
                      },
                    },
                    [_vm._v("http://www.apache.org/licenses/LICENSE-2.0")]
                  ),
                ]),
              ]),
              _c("li", [
                _c("b", [_vm._v("Jackson Dataformat Properties")]),
                _c("p", [
                  _c("b", [
                    _vm._v("Copyright: 2013, FasterXML, LLC, Seattle, USA"),
                  ]),
                ]),
                _c("p", [
                  _vm._v(
                    " The Software contains Jackson Dataformat Properties, which is licensed under the Apache License, Version 2.0. You can get the full source code for Jackson Databind at: "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://github.com/FasterXML/jackson-dataformat-properties/",
                      },
                    },
                    [
                      _vm._v(
                        "https://github.com/FasterXML/jackson-dataformat-properties"
                      ),
                    ]
                  ),
                  _vm._v(
                    " A copy of the Apache License, Version 2.0 is available at "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "http://www.apache.org/licenses/LICENSE-2.0",
                      },
                    },
                    [_vm._v("http://www.apache.org/licenses/LICENSE-2.0")]
                  ),
                ]),
              ]),
              _c("li", [
                _c("b", [_vm._v("Logback Classic & Core Modules")]),
                _c("p", [_c("b", [_vm._v("Copyright © 2019 QOS.ch")])]),
                _c("p", [
                  _vm._v(
                    " The Software contains the Logback Classic and Core Modules, which is licensed under the Eclipse Public License, Version 1.0. You can get the full source code for the Logback Classic & Core Modules at: "
                  ),
                  _c(
                    "a",
                    { attrs: { href: "https://logback.qos.ch/download.html" } },
                    [_vm._v("https://logback.qos.ch/download.html")]
                  ),
                  _vm._v(
                    " A copy of the Eclipse Public License, Version 1.0 is available at "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "http://www.eclipse.org/legal/epl-v10.html",
                      },
                    },
                    [_vm._v("http://www.eclipse.org/legal/epl-v10.html")]
                  ),
                ]),
              ]),
              _c("li", [
                _c("b", [_vm._v("SLF4J")]),
                _c("p", [_c("b", [_vm._v("Copyright © 2004-2019 QOS.ch")])]),
                _c("p", [
                  _vm._v(
                    " The Software contains SLF4J, which is licensed under the MIT License. You can get the full source code for SLF4J at: "
                  ),
                  _c(
                    "a",
                    { attrs: { href: "http://www.slf4j.org/download.html" } },
                    [_vm._v("http://www.slf4j.org/download.html")]
                  ),
                  _vm._v(" A copy of the MIT License is available at "),
                  _c(
                    "a",
                    { attrs: { href: "http://www.slf4j.org/license.html" } },
                    [_vm._v("http://www.slf4j.org/license.html")]
                  ),
                ]),
              ]),
              _c("li", [
                _c("b", [_vm._v("Apache Log4j")]),
                _c("p", [
                  _c("b", [
                    _vm._v("Copyright © 1999-2012 Apache Software Foundation."),
                  ]),
                ]),
                _c("p", [
                  _vm._v(
                    " The Software contains Apache Log4j, which is licensed under the Apache License, Version 2.0. You can get the full source code for Apache Log4j at: "
                  ),
                  _c(
                    "a",
                    { attrs: { href: "http://logging.apache.org/log4j/1.2/" } },
                    [_vm._v("http://logging.apache.org/log4j/1.2")]
                  ),
                  _vm._v(
                    " A copy of the Apache License, Version 2.0 is available at "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "http://www.apache.org/licenses/LICENSE-2.0",
                      },
                    },
                    [_vm._v("http://www.apache.org/licenses/LICENSE-2.0")]
                  ),
                ]),
              ]),
              _c("li", [
                _c("b", [_vm._v("Apache Commons Codec")]),
                _c("p", [
                  _c("b", [
                    _vm._v(
                      "Copyright © 2002-2014 The Apache Software Foundation. All Rights Reserved."
                    ),
                  ]),
                ]),
                _c("p", [
                  _vm._v(
                    " The Software contains Apache Commons Codec, which is licensed under the Apache License, Version 2.0. You can find more information at: "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "http://commons.apache.org/proper/commons-codec/",
                      },
                    },
                    [_vm._v("http://commons.apache.org/proper/commons-codec")]
                  ),
                  _vm._v(
                    " A copy of the Apache License, Version 2.0 is available at "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "http://www.apache.org/licenses/LICENSE-2.0",
                      },
                    },
                    [_vm._v("http://www.apache.org/licenses/LICENSE-2.0")]
                  ),
                ]),
              ]),
              _c("li", [
                _c("b", [_vm._v("Apache Commons Logging")]),
                _c("p", [
                  _c("b", [
                    _vm._v(
                      "Copyright © 2001-2014 The Apache Software Foundation. All Rights Reserved."
                    ),
                  ]),
                ]),
                _c("p", [
                  _vm._v(
                    " The Software contains Apache Commons Logging, which is licensed under the Apache License, Version 2.0. You can find more information at: "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "http://commons.apache.org/proper/commons-logging/",
                      },
                    },
                    [_vm._v("http://commons.apache.org/proper/commons-logging")]
                  ),
                  _vm._v(
                    " A copy of the Apache License, Version 2.0 is available at "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "http://www.apache.org/licenses/LICENSE-2.0",
                      },
                    },
                    [_vm._v("http://www.apache.org/licenses/LICENSE-2.0")]
                  ),
                ]),
              ]),
              _c("li", [
                _c("b", [_vm._v("Apache Commons FileUpload")]),
                _c("p", [
                  _c("b", [
                    _vm._v(
                      "Copyright © 2002-2019 The Apache Software Foundation. All Rights Reserved."
                    ),
                  ]),
                ]),
                _c("p", [
                  _vm._v(
                    " The Software contains Apache Commons FileUpload, which is licensed under the Apache License, Version 2.0. You can find more information at: "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "http://commons.apache.org/proper/commons-fileupload/",
                      },
                    },
                    [
                      _vm._v(
                        "http://commons.apache.org/proper/commons-fileupload"
                      ),
                    ]
                  ),
                  _vm._v(
                    " A copy of the Apache License, Version 2.0 is available at "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "http://www.apache.org/licenses/LICENSE-2.0",
                      },
                    },
                    [_vm._v("http://www.apache.org/licenses/LICENSE-2.0")]
                  ),
                ]),
              ]),
              _c("li", [
                _c("b", [_vm._v("Apache Commons IO")]),
                _c("p", [
                  _c("b", [
                    _vm._v(
                      "Copyright © 2002-2020 The Apache Software Foundation. All Rights Reserved."
                    ),
                  ]),
                ]),
                _c("p", [
                  _vm._v(
                    " The Software contains Apache Commons IO, which is licensed under the Apache License, Version 2.0. You can find more information at: "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "http://commons.apache.org/proper/commons-io/",
                      },
                    },
                    [_vm._v("http://commons.apache.org/proper/commons-io")]
                  ),
                  _vm._v(
                    " A copy of the Apache License, Version 2.0 is available at "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "http://www.apache.org/licenses/LICENSE-2.0",
                      },
                    },
                    [_vm._v("http://www.apache.org/licenses/LICENSE-2.0")]
                  ),
                ]),
              ]),
              _c("li", [
                _c("b", [_vm._v("Apache Commons Lang")]),
                _c("p", [
                  _c("b", [
                    _vm._v(
                      "Copyright © 2001-2020 The Apache Software Foundation. All Rights Reserved."
                    ),
                  ]),
                ]),
                _c("p", [
                  _vm._v(
                    " The Software contains Apache Commons Lang, which is licensed under the Apache License, Version 2.0. You can find more information at: "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "http://commons.apache.org/proper/commons-lang/",
                      },
                    },
                    [_vm._v("http://commons.apache.org/proper/commons-lang")]
                  ),
                  _vm._v(
                    " A copy of the Apache License, Version 2.0 is available at "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "http://www.apache.org/licenses/LICENSE-2.0",
                      },
                    },
                    [_vm._v("http://www.apache.org/licenses/LICENSE-2.0")]
                  ),
                ]),
              ]),
              _c("li", [
                _c("b", [_vm._v("Apache Commons BeanUtils")]),
                _c("p", [
                  _c("b", [
                    _vm._v(
                      "Copyright © 2000-2019 The Apache Software Foundation. All Rights Reserved."
                    ),
                  ]),
                ]),
                _c("p", [
                  _vm._v(
                    " The Software contains Apache Commons BeanUtils, which is licensed under the Apache License, Version 2.0. You can find more information at: "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "http://commons.apache.org/proper/commons-beanutils/",
                      },
                    },
                    [
                      _vm._v(
                        "http://commons.apache.org/proper/commons-beanutils"
                      ),
                    ]
                  ),
                  _vm._v(
                    " A copy of the Apache License, Version 2.0 is available at "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "http://www.apache.org/licenses/LICENSE-2.0",
                      },
                    },
                    [_vm._v("http://www.apache.org/licenses/LICENSE-2.0")]
                  ),
                ]),
              ]),
              _c("li", [
                _c("b", [_vm._v("Apache Commons Collections")]),
                _c("p", [
                  _c("b", [
                    _vm._v(
                      "Copyright © 2001-2020 The Apache Software Foundation. All Rights Reserved."
                    ),
                  ]),
                ]),
                _c("p", [
                  _vm._v(
                    " The Software contains Apache Commons Collections, which is licensed under the Apache License, Version 2.0. You can find more information at: "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "http://commons.apache.org/proper/commons-collections/",
                      },
                    },
                    [
                      _vm._v(
                        "http://commons.apache.org/proper/commons-collections"
                      ),
                    ]
                  ),
                  _vm._v(
                    " A copy of the Apache License, Version 2.0 is available at "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "http://www.apache.org/licenses/LICENSE-2.0",
                      },
                    },
                    [_vm._v("http://www.apache.org/licenses/LICENSE-2.0")]
                  ),
                ]),
              ]),
              _c("li", [
                _c("b", [_vm._v("Apache Commons Compress")]),
                _c("p", [
                  _c("b", [
                    _vm._v(
                      "Copyright © 2020 The Apache Software Foundation. All Rights Reserved."
                    ),
                  ]),
                ]),
                _c("p", [
                  _vm._v(
                    " The Software contains Apache Commons Compress, which is licensed under the Apache License, Version 2.0. You can find more information at: "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "http://commons.apache.org/proper/commons-compress/",
                      },
                    },
                    [
                      _vm._v(
                        "http://commons.apache.org/proper/commons-compress"
                      ),
                    ]
                  ),
                  _vm._v(
                    " A copy of the Apache License, Version 2.0 is available at "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "http://www.apache.org/licenses/LICENSE-2.0",
                      },
                    },
                    [_vm._v("http://www.apache.org/licenses/LICENSE-2.0")]
                  ),
                ]),
              ]),
              _c("li", [
                _c("b", [_vm._v("Apache Felix")]),
                _c("p", [
                  _c("b", [
                    _vm._v(
                      "Copyright © 2020 The Apache Software Foundation. All Rights Reserved."
                    ),
                  ]),
                ]),
                _c("p", [
                  _vm._v(
                    " The Software contains Apache Felix, which is licensed under the Apache License, Version 2.0. You can find more information at: "
                  ),
                  _c("a", { attrs: { href: "https://felix.apache.org/" } }, [
                    _vm._v("https://felix.apache.org"),
                  ]),
                  _vm._v(
                    " A copy of the Apache License, Version 2.0 is available at "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "http://www.apache.org/licenses/LICENSE-2.0",
                      },
                    },
                    [_vm._v("http://www.apache.org/licenses/LICENSE-2.0")]
                  ),
                ]),
              ]),
              _c("li", [
                _c("b", [_vm._v("Apache Tomcat")]),
                _c("p", [
                  _c("b", [
                    _vm._v(
                      "Copyright © 1999-2020 The Apache Software Foundation. All Rights Reserved."
                    ),
                  ]),
                ]),
                _c("p", [
                  _vm._v(
                    " The Software contains Apache Tomcat, which is licensed under the Apache License, Version 2.0. You can find more information at: "
                  ),
                  _c("a", { attrs: { href: "https://tomcat.apache.org/" } }, [
                    _vm._v("https://tomcat.apache.org"),
                  ]),
                  _vm._v(
                    " A copy of the Apache License, Version 2.0 is available at "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "http://www.apache.org/licenses/LICENSE-2.0",
                      },
                    },
                    [_vm._v("http://www.apache.org/licenses/LICENSE-2.0")]
                  ),
                ]),
              ]),
              _c("li", [
                _c("b", [_vm._v("Bouncy Castle Provider")]),
                _c("p", [
                  _c("b", [
                    _vm._v(
                      "Copyright © 2000-2020 The Apache Software Foundation. All Rights Reserved."
                    ),
                  ]),
                ]),
                _c("p", [
                  _vm._v(
                    " The Software contains Bouncy Castle Provider, which is licensed under the Bouncy Castle License. You can find more information at: "
                  ),
                  _c(
                    "a",
                    { attrs: { href: "https://www.bouncycastle.org/" } },
                    [_vm._v("https://www.bouncycastle.org")]
                  ),
                  _vm._v(
                    " A copy of the Bouncy Castle License is available at "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://www.bouncycastle.org/licence.html",
                      },
                    },
                    [_vm._v("https://www.bouncycastle.org/licence.html")]
                  ),
                ]),
              ]),
              _c("li", [
                _c("b", [_vm._v("JSON Web Tokens")]),
                _c("p", [
                  _c("b", [_vm._v("Copyright (c) 2013-2014 Auth0 Inc.")]),
                ]),
                _c("p", [
                  _vm._v(
                    " The Software contains JSON Web Tokens, which is licensed under the MIT License. You can find more information at: "
                  ),
                  _c("a", { attrs: { href: "https://jwt.io//" } }, [
                    _vm._v("https://jwt.io/"),
                  ]),
                  _vm._v(" A copy of the license is available at "),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://github.com/jsonwebtoken/jsonwebtoken.github.io/blob/master/LICENSE.txt",
                      },
                    },
                    [
                      _vm._v(
                        "https://github.com/jsonwebtoken/jsonwebtoken.github.io/blob/master/LICENSE.txt"
                      ),
                    ]
                  ),
                ]),
              ]),
              _c("li", [
                _c("b", [_vm._v("Eclipse Tahu")]),
                _c("p", [
                  _c("b", [
                    _vm._v(
                      "Copyright © 2014-2019 Cirrus Link Solutions and others"
                    ),
                  ]),
                ]),
                _c("p", [
                  _vm._v(
                    " The Software contains Eclipse Tahu, which is licensed under the Eclipse Public License, Version 2.0. You can get the full source code for Eclipse Tahu at: "
                  ),
                  _c(
                    "a",
                    { attrs: { href: "https://github.com/eclipse/tahu" } },
                    [_vm._v("https://github.com/eclipse/tahu")]
                  ),
                  _vm._v(
                    " A copy of the Eclipse Public License, Version 2.0 is available at "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "http://www.eclipse.org/legal/epl-v20.html",
                      },
                    },
                    [_vm._v("http://www.eclipse.org/legal/epl-v20.html")]
                  ),
                ]),
              ]),
              _c("li", [
                _c("b", [_vm._v("Eclipse Jetty")]),
                _c("p", [
                  _c("b", [_vm._v("Copyright © The Eclipse Foundation")]),
                ]),
                _c("p", [
                  _vm._v(
                    " The Software contains Eclipse Jetty 9, which is dual licensed under the Apache License 2.0 and Eclipse Public License 1.0. You can find more information at: "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://www.eclipse.org/jetty/licenses.php",
                      },
                    },
                    [_vm._v("https://www.eclipse.org/jetty/licenses.php")]
                  ),
                  _vm._v(
                    " A copy of the Eclipse Public License, Version 1.0 is available at . "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://www.eclipse.org/legal/epl-v10.html",
                      },
                    },
                    [_vm._v("https://www.eclipse.org/legal/epl-v10.html")]
                  ),
                  _vm._v(
                    " A copy of the Apache License, Version 2.0 is available at http://www.apache.org/licenses/LICENSE-2.0 "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "http://www.apache.org/licenses/LICENSE-2.0",
                      },
                    },
                    [_vm._v("http://www.apache.org/licenses/LICENSE-2.0")]
                  ),
                ]),
              ]),
              _c("li", [
                _c("b", [_vm._v("Google Protocol Buffers")]),
                _c("p", [
                  _c("b", [
                    _vm._v(
                      "Copyright © 2014, Google Inc. All rights reserved."
                    ),
                  ]),
                ]),
                _c("p", [
                  _vm._v(
                    " The Software contains Google Protocol Buffers, which is licensed under a BSD style license. You can get the full source code for Google Protocol Buffers at: "
                  ),
                  _c(
                    "a",
                    { attrs: { href: "https://github.com/google/protobuf" } },
                    [_vm._v("https://github.com/google/protobuf")]
                  ),
                  _vm._v(" A copy of the license is available at "),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://github.com/google/protobuf/blob/master/LICENSE",
                      },
                    },
                    [
                      _vm._v(
                        "https://github.com/google/protobuf/blob/master/LICENSE"
                      ),
                    ]
                  ),
                ]),
              ]),
              _c("li", [
                _c("b", [_vm._v("Google Conscrypt")]),
                _c("p", [
                  _c("b", [
                    _vm._v("Copyright: © 2016 The Android Open Source Project"),
                  ]),
                ]),
                _c("p", [
                  _vm._v(
                    " The Software contains Google Conscrypt, which is licensed under the Apache License, Version 2.0. You can find more information at: "
                  ),
                  _c("a", { attrs: { href: "https://conscrypt.org/" } }, [
                    _vm._v("https://conscrypt.org/"),
                  ]),
                  _vm._v(
                    " A copy of the Apache License, Version 2.0 is available at "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "http://www.apache.org/licenses/LICENSE-2.0",
                      },
                    },
                    [_vm._v("http://www.apache.org/licenses/LICENSE-2.0")]
                  ),
                ]),
              ]),
              _c("li", [
                _c("b", [_vm._v("OSGi Companion Code")]),
                _c("p", [
                  _c("b", [_vm._v("Copyright © 2011-2018 LICENSE4J.")]),
                ]),
                _c("p", [
                  _vm._v(
                    " The Software contains the OSGi Companion Code code, which is licensed under the OSGi Specification License, Version 2.0. You can find more information at: "
                  ),
                  _c(
                    "a",
                    { attrs: { href: "https://www.osgi.org/release-6-1/" } },
                    [_vm._v("https://www.osgi.org/release-6-1/")]
                  ),
                ]),
              ]),
              _c("li", [
                _c("b", [_vm._v("TestNG")]),
                _c("p", [
                  _c("b", [
                    _vm._v(
                      "Copyright © 2004-2019 Cédric Beust, the TestNG team"
                    ),
                  ]),
                ]),
                _c("p", [
                  _vm._v(
                    " The Software contains the TestNG, which is licensed under the Apache License, Version 2.0. You can find more information at: "
                  ),
                  _c("a", { attrs: { href: "https://testng.org/" } }, [
                    _vm._v("https://testng.org/"),
                  ]),
                  _vm._v(
                    " A copy of the Apache License, Version 2.0 is available at "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "http://www.apache.org/licenses/LICENSE-2.0",
                      },
                    },
                    [_vm._v("http://www.apache.org/licenses/LICENSE-2.0")]
                  ),
                ]),
              ]),
              _c("li", [
                _c("b", [_vm._v("junixsocket")]),
                _c("p", [
                  _c("b", [
                    _vm._v("Copyright © 2009-2022 Christian Kohlschütter"),
                  ]),
                ]),
                _c("p", [
                  _vm._v(
                    " The Software contains junixsocket, which is licensed under the Apache License 2.0 "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://github.com/kohlschutter/junixsocket/blob/main/NOTICE",
                      },
                    },
                    [
                      _vm._v(
                        "https://github.com/kohlschutter/junixsocket/blob/main/NOTICE"
                      ),
                    ]
                  ),
                ]),
              ]),
              _c("li", [
                _c("b", [_vm._v("License4J Runtime Library")]),
                _c("p", [_c("b", [_vm._v("Copyright © 2011-2018 LICENSE4J")])]),
                _c("p", [
                  _vm._v(" This Software contains License4J Runtime Library "),
                  _c("a", { attrs: { href: "https://www.license4j.com" } }, [
                    _vm._v("https://www.license4j.com"),
                  ]),
                ]),
              ]),
              _c("li", [
                _c("b", [_vm._v("Java-WebSocket")]),
                _c("p", [
                  _c("b", [_vm._v("Copyright © 2010-2020 Nathan Rajlich")]),
                ]),
                _c("p", [
                  _vm._v(
                    " The Software contains Java-WebSocket, which is licensed under MIT License "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://github.com/TooTallNate/Java-WebSocket/blob/master/LICENSE",
                      },
                    },
                    [
                      _vm._v(
                        "https://github.com/TooTallNate/Java-WebSocket/blob/master/LICENSE"
                      ),
                    ]
                  ),
                ]),
              ]),
              _c("li", [
                _c("b", [_vm._v("OSGi Core")]),
                _c("p", [
                  _c("b", [_vm._v("Copyright © 2000-2015 OSGi Alliance")]),
                ]),
                _c("p", [
                  _vm._v(
                    " The Software contains OSGi Core, which is licensed under the OSGi Specification License, Version 2.0 "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://docs.osgi.org/javadoc/r6/core/LICENSE.html",
                      },
                    },
                    [
                      _vm._v(
                        "https://docs.osgi.org/javadoc/r6/core/LICENSE.html"
                      ),
                    ]
                  ),
                ]),
              ]),
              _c("li", [
                _c("b", [_vm._v("gethostname4j")]),
                _c("p", [_c("b", [_vm._v("Copyright © 2017 Matt Sheppard")])]),
                _c("p", [
                  _vm._v(
                    " The Software contains gethostname4j, which is licensed under MIT License "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://github.com/mattsheppard/gethostname4j/blob/master/LICENSE",
                      },
                    },
                    [
                      _vm._v(
                        "https://github.com/mattsheppard/gethostname4j/blob/master/LICENSE"
                      ),
                    ]
                  ),
                ]),
              ]),
              _c("li", [
                _c("b", [_vm._v("JCommander")]),
                _c("p", [
                  _c("b", [_vm._v("Copyright © 2004-2019 Cédric Beust")]),
                ]),
                _c("p", [
                  _vm._v(
                    " The Software contains the JCommander, which is licensed under the Apache License, Version 2.0. You can find more information at: "
                  ),
                  _c("a", { attrs: { href: "https://jcommander.org/" } }, [
                    _vm._v("https://jcommander.org"),
                  ]),
                  _vm._v(
                    " A copy of the Apache License, Version 2.0 is available at "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "http://www.apache.org/licenses/LICENSE-2.0",
                      },
                    },
                    [_vm._v("http://www.apache.org/licenses/LICENSE-2.0")]
                  ),
                ]),
              ]),
              _c("li", [
                _c("b", [_vm._v("SnakeYAML")]),
                _c("p", [
                  _c("b", [
                    _vm._v("Copyright (c) 2008, http://www.snakeyaml.org"),
                  ]),
                ]),
                _c("p", [
                  _vm._v(
                    " The Software contains the SnakeYAML, which is licensed under the Apache License, Version 2.0. You can find more information at: "
                  ),
                  _c("a", { attrs: { href: "http://www.snakeyaml.org/" } }, [
                    _vm._v("http://www.snakeyaml.org"),
                  ]),
                  _vm._v(
                    " A copy of the Apache License, Version 2.0 is available at "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "http://www.apache.org/licenses/LICENSE-2.0",
                      },
                    },
                    [_vm._v("http://www.apache.org/licenses/LICENSE-2.0")]
                  ),
                ]),
              ]),
              _c("li", [
                _c("b", [_vm._v("AssertJ Core")]),
                _c("p", [
                  _c("b", [
                    _vm._v(
                      "Copyright 2012-2016, the original author or authors"
                    ),
                  ]),
                ]),
                _c("p", [
                  _vm._v(
                    " The Software contains the AssertJ Core, which is licensed under the Apache License, Version 2.0. You can find more information at: "
                  ),
                  _c(
                    "a",
                    { attrs: { href: "https://assertj.github.io/doc/" } },
                    [_vm._v("https://assertj.github.io/doc")]
                  ),
                  _vm._v(
                    " A copy of the Apache License, Version 2.0 is available at "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "http://www.apache.org/licenses/LICENSE-2.0",
                      },
                    },
                    [_vm._v("http://www.apache.org/licenses/LICENSE-2.0")]
                  ),
                ]),
              ]),
              _c("li", [
                _c("b", [_vm._v("JUnit")]),
                _c("p", [
                  _c("b", [
                    _vm._v("Copyright © 2002-2014 JUnit. All Rights Reserved."),
                  ]),
                ]),
                _c("p", [
                  _vm._v(
                    " The Software contains the JUnit, which is licensed under the Eclipse Public License, Version 1.0. You can find more information at: "
                  ),
                  _c("a", { attrs: { href: "https://junit.org/junit4/" } }, [
                    _vm._v("https://junit.org/junit4"),
                  ]),
                  _vm._v(
                    " A copy of the Eclipse Public License, Version 1.0 is available at "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://www.eclipse.org/legal/epl-v10.html",
                      },
                    },
                    [_vm._v("https://www.eclipse.org/legal/epl-v10.html")]
                  ),
                ]),
              ]),
              _c("li", [
                _c("b", [_vm._v("Java Hamcrest")]),
                _c("p", [
                  _c("b", [_vm._v("Copyright © 2012-2019 hamcrest.org")]),
                ]),
                _c("p", [
                  _vm._v(
                    " The Software contains the Java Hamcrest, which is licensed under the BSD License. You can find more information at: "
                  ),
                  _c(
                    "a",
                    { attrs: { href: "http://hamcrest.org/JavaHamcrest/" } },
                    [_vm._v("http://hamcrest.org/JavaHamcrest")]
                  ),
                  _vm._v(". A copy of the BSD License is available at "),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://opensource.org/licenses/BSD-3-Clause",
                      },
                    },
                    [_vm._v("https://opensource.org/licenses/BSD-3-Clause")]
                  ),
                ]),
              ]),
              _c("li", [
                _c("b", [_vm._v("H2 Database")]),
                _c("p", [_c("b", [_vm._v("Copyright © 2017 QOS.ch")])]),
                _c("p", [
                  _vm._v(
                    " The Software contains the H2 Database, which is licensed under either the Eclipse Public License, Version 1.0 or the Mozilla Public License, Version 2.0. You can get the full source code for the H2 Database at: "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://github.com/h2database/h2database",
                      },
                    },
                    [_vm._v("https://github.com/h2database/h2database")]
                  ),
                  _vm._v(
                    ". A copy of the Eclipse Public License, Version 1.0 is available at "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "http://www.eclipse.org/legal/epl-v10.html",
                      },
                    },
                    [_vm._v("http://www.eclipse.org/legal/epl-v10.html")]
                  ),
                  _vm._v(
                    " A copy of the Mozilla Public License, Version 2.0 is available at "
                  ),
                  _c(
                    "a",
                    {
                      attrs: { href: "https://www.mozilla.org/en-US/MPL/2.0/" },
                    },
                    [_vm._v("https://www.mozilla.org/en-US/MPL/2.0/")]
                  ),
                ]),
              ]),
              _c("li", [
                _c("b", [_vm._v("Axios")]),
                _c("p", [
                  _c("b", [_vm._v("Copyright (c) 2014-2020 Matt Zabriskie")]),
                ]),
                _c("p", [
                  _vm._v(
                    " The Software contains Axios, which is licensed under the MIT license. You can get the full source code for Axios: "
                  ),
                  _c(
                    "a",
                    { attrs: { href: "https://github.com/axios/axios" } },
                    [_vm._v("https://github.com/axios/axios")]
                  ),
                  _vm._v(". A copy of the license is available at "),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://github.com/axios/axios/blob/master/LICENSE",
                      },
                    },
                    [
                      _vm._v(
                        "https://github.com/axios/axios/blob/master/LICENSE"
                      ),
                    ]
                  ),
                ]),
              ]),
              _c("li", [
                _c("b", [_vm._v("Bootstrap")]),
                _c("p", [
                  _vm._v(
                    " The Software contains Bootstrap, which is licensed under the MIT license. You can get the full source code for Bootstrap: "
                  ),
                  _c(
                    "a",
                    { attrs: { href: "https://github.com/twbs/bootstrap" } },
                    [_vm._v("https://github.com/twbs/bootstrap")]
                  ),
                  _vm._v(". A copy of the license is available at "),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://github.com/twbs/bootstrap/blob/main/LICENSE",
                      },
                    },
                    [
                      _vm._v(
                        "https://github.com/twbs/bootstrap/blob/main/LICENSE"
                      ),
                    ]
                  ),
                ]),
              ]),
              _c("li", [
                _c("b", [_vm._v("BootstrapVue")]),
                _c("p", [
                  _vm._v(
                    " The Software contains BootstrapVue, which is licensed under the MIT license. You can get the full source code for BootstrapVue: "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://github.com/bootstrap-vue/bootstrap-vue",
                      },
                    },
                    [_vm._v("https://github.com/bootstrap-vue/bootstrap-vue")]
                  ),
                  _vm._v(". A copy of the license is available at "),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://github.com/bootstrap-vue/bootstrap-vue/blob/dev/LICENSE",
                      },
                    },
                    [
                      _vm._v(
                        "https://github.com/bootstrap-vue/bootstrap-vue/blob/dev/LICENSE"
                      ),
                    ]
                  ),
                ]),
              ]),
              _c("li", [
                _c("b", [_vm._v("core-js")]),
                _c("p", [
                  _c("b", [_vm._v("Copyright (c) 2014-2020 Denis Pushkarev")]),
                ]),
                _c("p", [
                  _vm._v(
                    " The Software contains core-js, which is licensed under the MIT license. You can get the full source code for core-js: "
                  ),
                  _c(
                    "a",
                    { attrs: { href: "https://github.com/zloirock/core-js" } },
                    [_vm._v("https://github.com/zloirock/core-js")]
                  ),
                  _vm._v(". A copy of the license is available at "),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://github.com/zloirock/core-js/blob/master/LICENSE",
                      },
                    },
                    [
                      _vm._v(
                        "https://github.com/zloirock/core-js/blob/master/LICENSE"
                      ),
                    ]
                  ),
                ]),
              ]),
              _c("li", [
                _c("b", [_vm._v("Day.js")]),
                _c("p", [_c("b", [_vm._v("Copyright (c) 2018-2020, iamkun")])]),
                _c("p", [
                  _vm._v(
                    " The Software contains Day.js, which is licensed under the MIT license. You can get the full source code for Day.js: "
                  ),
                  _c(
                    "a",
                    { attrs: { href: "https://github.com/iamkun/dayjs" } },
                    [_vm._v("https://github.com/iamkun/dayjs")]
                  ),
                  _vm._v(". A copy of the license is available at "),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://github.com/iamkun/dayjs/blob/dev/LICENSE",
                      },
                    },
                    [_vm._v("https://github.com/iamkun/dayjs/blob/dev/LICENSE")]
                  ),
                ]),
              ]),
              _c("li", [
                _c("b", [_vm._v("Interaction Observer")]),
                _c("p", [
                  _c("b", [
                    _vm._v("Copyright 2016 Google Inc. All Rights Reserved."),
                  ]),
                ]),
                _c("p", [
                  _vm._v(
                    " The Software contains Interaction Observer, which is licensed under the W3C license. You can get the full source code for Interaction Observer: "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://github.com/w3c/IntersectionObserver",
                      },
                    },
                    [_vm._v("https://github.com/w3c/IntersectionObserver")]
                  ),
                  _vm._v(". A copy of the license is available at "),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document",
                      },
                    },
                    [
                      _vm._v(
                        "https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document"
                      ),
                    ]
                  ),
                ]),
              ]),
              _c("li", [
                _c("b", [_vm._v("serve")]),
                _c("p", [_c("b", [_vm._v("Copyright (c) 2018 ZEIT, Inc.")])]),
                _c("p", [
                  _vm._v(
                    " The Software contains serve, which is licensed under the MIT license. You can get the full source code for serve: "
                  ),
                  _c(
                    "a",
                    { attrs: { href: "https://github.com/vercel/serve" } },
                    [_vm._v("https://github.com/vercel/serve")]
                  ),
                  _vm._v(". A copy of the license is available at "),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://github.com/vercel/serve/blob/master/LICENSE",
                      },
                    },
                    [
                      _vm._v(
                        "https://github.com/vercel/serve/blob/master/LICENSE"
                      ),
                    ]
                  ),
                ]),
              ]),
              _c("li", [
                _c("b", [_vm._v("vue")]),
                _c("p", [
                  _c("b", [_vm._v("Copyright (c) 2013-2020, Yuxi (Evan) You")]),
                ]),
                _c("p", [
                  _vm._v(
                    " The Software contains vue, which is licensed under the MIT license. You can get the full source code for vue: "
                  ),
                  _c("a", { attrs: { href: "https://github.com/vuejs/vue" } }, [
                    _vm._v("https://github.com/vuejs/vue"),
                  ]),
                  _vm._v(". A copy of the license is available at "),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://github.com/vuejs/vue/blob/dev/LICENSE",
                      },
                    },
                    [_vm._v("https://github.com/vuejs/vue/blob/dev/LICENSE")]
                  ),
                ]),
              ]),
              _c("li", [
                _c("b", [_vm._v("vue-awesome-countdown")]),
                _c("p", [_c("b", [_vm._v("Copyright (c) 2018 LinQuan")])]),
                _c("p", [
                  _vm._v(
                    " The Software contains vue-awesome-countdown, which is licensed under the MIT license. You can get the full source code for vue-awesome-countdown: "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://github.com/mlinquan/vue-awesome-countdown",
                      },
                    },
                    [
                      _vm._v(
                        "https://github.com/mlinquan/vue-awesome-countdown"
                      ),
                    ]
                  ),
                  _vm._v(". A copy of the license is available at "),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://github.com/mlinquan/vue-awesome-countdown/blob/master/LICENSE",
                      },
                    },
                    [
                      _vm._v(
                        "https://github.com/mlinquan/vue-awesome-countdown/blob/master/LICENSE"
                      ),
                    ]
                  ),
                ]),
              ]),
              _c("li", [
                _c("b", [_vm._v("vue-clipboard2")]),
                _c("p", [_c("b", [_vm._v("Copyright (c) 2017 Inndy")])]),
                _c("p", [
                  _vm._v(
                    " The Software contains vue-clipboard2, which is licensed under the MIT license. You can get the full source code for vue-clipboard2: "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://github.com/Inndy/vue-clipboard2",
                      },
                    },
                    [_vm._v("https://github.com/Inndy/vue-clipboard2")]
                  ),
                  _vm._v(". A copy of the license is available at "),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://github.com/Inndy/vue-clipboard2/blob/master/LICENSE",
                      },
                    },
                    [
                      _vm._v(
                        "https://github.com/Inndy/vue-clipboard2/blob/master/LICENSE"
                      ),
                    ]
                  ),
                ]),
              ]),
              _c("li", [
                _c("b", [_vm._v("vue-i18n")]),
                _c("p", [
                  _c("b", [_vm._v("Copyright © 2020 kazuya kawaguchi")]),
                ]),
                _c("p", [
                  _vm._v(
                    " The Software contains vue-i18n, which is licensed under the MIT license. You can get the full source code for vue-i18n: "
                  ),
                  _c(
                    "a",
                    { attrs: { href: "https://github.com/kazupon/vue-i18n" } },
                    [_vm._v("https://github.com/kazupon/vue-i18n")]
                  ),
                  _vm._v(". A copy of the license is available at "),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://github.com/kazupon/vue-i18n/blob/v8.x/LICENSE",
                      },
                    },
                    [
                      _vm._v(
                        "https://github.com/kazupon/vue-i18n/blob/v8.x/LICENSE"
                      ),
                    ]
                  ),
                ]),
              ]),
              _c("li", [
                _c("b", [_vm._v("vue-multiselect")]),
                _c("p", [
                  _c("b", [_vm._v("Copyright (c) 2016 Damian Dulisz")]),
                ]),
                _c("p", [
                  _vm._v(
                    " The Software contains vue-multiselect, which is licensed under the MIT license. You can get the full source code for vue-multiselect: "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://github.com/shentao/vue-multiselect",
                      },
                    },
                    [_vm._v("https://github.com/shentao/vue-multiselect")]
                  ),
                  _vm._v(". A copy of the license is available at "),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://github.com/shentao/vue-multiselect/blob/master/LICENSE",
                      },
                    },
                    [
                      _vm._v(
                        "https://github.com/shentao/vue-multiselect/blob/master/LICENSE"
                      ),
                    ]
                  ),
                ]),
              ]),
              _c("li", [
                _c("b", [_vm._v("vue-router")]),
                _c("p", [
                  _c("b", [_vm._v("Copyright (c) 2013-2020 Evan You")]),
                ]),
                _c("p", [
                  _vm._v(
                    " The Software contains vue-router, which is licensed under the MIT license. You can get the full source code for vue-router: "
                  ),
                  _c(
                    "a",
                    { attrs: { href: "https://github.com/vuejs/vue-router" } },
                    [_vm._v("https://github.com/vuejs/vue-router")]
                  ),
                  _vm._v(". A copy of the license is available at "),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://github.com/vuejs/vue-router/blob/dev/LICENSE",
                      },
                    },
                    [
                      _vm._v(
                        "https://github.com/vuejs/vue-router/blob/dev/LICENSE"
                      ),
                    ]
                  ),
                ]),
              ]),
              _c("li", [
                _c("b", [_vm._v("vuelidate")]),
                _c("p", [
                  _c("b", [_vm._v("Copyright (c) 2019 Damian Dulisz")]),
                ]),
                _c("p", [
                  _vm._v(
                    " The Software contains vuelidate, which is licensed under the MIT license. You can get the full source code for vuelidate: "
                  ),
                  _c(
                    "a",
                    {
                      attrs: { href: "https://github.com/vuelidate/vuelidate" },
                    },
                    [_vm._v("https://github.com/vuelidate/vuelidate")]
                  ),
                  _vm._v(". A copy of the license is available at "),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://github.com/vuelidate/vuelidate/blob/master/LICENSE",
                      },
                    },
                    [
                      _vm._v(
                        "https://github.com/vuelidate/vuelidate/blob/master/LICENSE"
                      ),
                    ]
                  ),
                ]),
              ]),
              _c("li", [
                _c("b", [_vm._v("vuex")]),
                _c("p", [
                  _c("b", [_vm._v("Copyright (c) 2015-2020 Evan You")]),
                ]),
                _c("p", [
                  _vm._v(
                    " The Software contains vuex, which is licensed under the MIT license. You can get the full source code for vuex: "
                  ),
                  _c(
                    "a",
                    { attrs: { href: "https://github.com/vuejs/vuex" } },
                    [_vm._v("https://github.com/vuejs/vuex")]
                  ),
                  _vm._v(". A copy of the license is available at "),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://github.com/vuejs/vuex/blob/dev/LICENSE",
                      },
                    },
                    [_vm._v("https://github.com/vuejs/vuex/blob/dev/LICENSE")]
                  ),
                ]),
              ]),
            ]),
          ]),
          _c("li", [
            _c("b", [_vm._v("OWNERSHIP OF SOFTWARE.")]),
            _vm._v(
              " The Software is protected by the laws of the United States and other countries, and through international treaty provisions. You may not remove any copyright notices from the Software. Cirrus Link may make changes to the Software at any time without notice, but is not obligated to support or update the Software Except asotherwise expressly provided in this CLSSLA, Cirrus Link grants no express or implied right under Cirrus Link patents, copyrights, trademarks or other intellectual property rights. "
            ),
          ]),
          _c("li", [
            _c("b", [_vm._v("PROHIBITIONS.")]),
            _vm._v(
              " Ownership of all copies of the Software remains with Cirrus Link. You are not obtaining ownership ofthe Software or any intellectual property rights related to it by licensing the Software. You may not sublicense, rent, lease,convey, translate, decompile or disassemble the Software for any purpose. Permission must be obtained before mirroring or redistributing the evaluation copies of the Software. You may not convert this Software or its parts to a different computer language or environment, either manually, or using an automated conversion tool, such that this Software or anymodification thereof will run under any language, software, or program other than implemented by Cirrus Link. You agree that any modifications made to this Software belong to Cirrus Link and are permitted for your exclusive use during the period of this CLSSLA, and may not be transferred, sold or licensed to another entity. "
            ),
          ]),
          _c("li", [
            _c("b", [_vm._v("WARRANTY.")]),
            _vm._v(
              " Cirrus Link warrants that it is the owner of the Software or has the right to grant the license (including the third party software licenses as more specifically provided under section 2 below) described in this CLSSLA without violating the rights of any third party. "
            ),
          ]),
          _c("li", [
            _c("b", [_vm._v("DISCLAIMER.")]),
            _vm._v(
              ' THE SOFTWARE IS PROVIDED ON AN "AS IS" BASIS, WITHOUT WARRANTIES OF ANY KIND, INCLUDING, WITHOUT LIMITATION, THE WARRANTIES OF: (a) MERCHANTABILITY; (b) FITNESS FOR A PARTICULAR PURPOSE; AND (c) NONINFRINGEMENT. YOU ASSUME THE ENTIRE RISK AS TO THE QUALITY AND PERFORMANCE OF THE SOFTWARE. SHOULD THE SOFTWARE PROVE DEFECTIVE, YOU ASSUME THE ENTIRE RISK OR COST ASSOCIATED WITH SUCH DEFECT AND ANY SERVICE AND REPAIR. '
            ),
          ]),
          _c("li", [
            _c("b", [_vm._v("LIMITATION OF LIABILITY.")]),
            _vm._v(
              " NEITHER CIRRUS LINK NOR ANYONE INVOLVED IN THE PRODUCTION OR DELIVERY OF THIS SOFTWARE SHALL BE LIABLE FOR ANY INDIRECT, CONSEQUENTIAL OR INCIDENTAL DAMAGES ARISING OUT OF THE USE OR INABILITY TO USE SUCH SOFTWARE EVEN IF CIRRUS LINK HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES OR CLAIMS. IN NO EVENT SHALL CIRRUS LINK LIABILITY FOR ANY DAMAGES EXCEED THE PRICE PAID FOR THE LICENSE TO USETHE SOFTWARE, REGARDLESS OF THE FORM OF CLAIM. THE PERSON USING THE SOFTWARE BEARS ALL RISK AS TO THE QUALITY AND PERFORMANCE OF THE SOFTWARE. "
            ),
          ]),
          _c("li", [
            _c("b", [_vm._v("EXPORT RESTRICTIONS.")]),
            _vm._v(
              " All Software and technical data delivered under this Agreement are subject to US export control laws and may be subject to export or import regulations in other countries. You agree to comply strictly with all such laws and regulations and acknowledge that you have the responsibility to obtain such licenses to export, re-export, orimport as may be required after delivery to you. These laws include restrictions on destinations, end users and end use. "
            ),
          ]),
          _c("li", [
            _c("b", [_vm._v("TERMINATION.")]),
            _vm._v(
              " This CLSSLA is effective until terminated. This CLSSLA terminates on the date of the first occurrence of either of the following events: (1) The expiration of one month from written notice of termination from Youto Cirrus Link; or (2) At any time if You violate the terms of this CLSSLA. Upon termination You shall destroy all copies of the Software, including modified copies, if any. You agree that monetary damages alone is not an adequate and just relief resulting from any breach of this CLSSLA, that a court order prohibiting any further breach of this CLSSLA is necessary to prevent further damages, and that you will not oppose any reasonable request for a temporary restraining order, preliminary injunction, or other relief sought by Cirrus Link in the event of a breach of this CLSSLA. Cirrus Link shall not be required to notify You of any breach, nor make any demand or claim against You resulting from any such breach, or for a demand to stop any use or distribution in violation of the terms of this CLSSLA, and You agree that any breach of this CLSSLA and damages resulting therefrom shall relate back to the first and earliest breach thereof. Failure of Cirrus Link to enforce its rights pursuant to this CLSSLA shall not constitute a waiver of such rights, and shall not prejudice Cirrus Link in any later enforcement of its rights or rights to seek damages therefrom. "
            ),
          ]),
          _c("li", [
            _c("b", [_vm._v("UPGRADES.")]),
            _vm._v(
              " If You acquired this Software as an upgrade of a previous version, this CLSSLA replaces and supersedes any prior CLSSLA. You may continue to use the previous version of the Software, provided that both the previous versionand the upgrade are installed on the same computer at all times. You may not have a previous version and the related upgrade version installed on separate computers at any time. Once you have installed the upgrades and are satisfied that the upgrades are operating correctly, You agree to uninstall any prior versions of the Software from all computers on which is was previously installed "
            ),
          ]),
          _c("li", [
            _c("b", [_vm._v("ENTIRE AGREEMENT.")]),
            _vm._v(
              " This CLSSLA is the entire agreement between You and Cirrus Link relating to your use of the Software, and supersedes all prior written or oral statements, promises, representations and agreements. "
            ),
          ]),
          _c("li", [
            _c("b", [_vm._v("GOVERNING LAW.")]),
            _vm._v(
              " The CLSSLA shall be governed by the laws of the State of Kansas. Any action or proceeding brought by either party against the other arising out of or related to this CLSSLA shall be brought only in a state or federal court of competent jurisdiction located in Johnson County, Kansas. The parties hereby consent to the jurisdiction of such courts. "
            ),
          ]),
          _c("li", [
            _c("b", [
              _vm._v("RIGHT TO IDENTIFY CUSTOMER IN MARKETING MATERIALS."),
            ]),
            _vm._v(
              " You agree that Cirrus Link may use your name (and logo if applicable) in its marketing materials solely for the purpose of identifying customers of Cirrus Link who have purchased its software. No explicit representations or warranties shall be made regarding your recommendation or endorsement of the Software. "
            ),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }